<template>
  <div class="app-container">
    <base-header v-if="showType" activeIndex="1" />

    <div :class="showType ? 'banner__layer' : 'banner__layer bannerss'">

      <img class="banner-img" src="@/assets/imgs/product/banner.png" />
      <img class="banner-imgs" src="@/assets/imgs/product/wap/banner.png" />


      <div :class="showType ? 'banner-content content-box' : 'banner-content content-box banner-co'">
        <h1 class="title"> 选对产品 选对平台</h1>
        <h1 class="titles">选对产品 </h1>
        <h1 class="titles">选对平台</h1>
        <p class="banner-content-intro">黄金交易所权威授权 · 您的信赖之选</p>
        <div class="banner-content-download">
          <router-link to="/Appdownload?key=1">
            <span class="banner-content-download-btn">APP下载</span>
          </router-link>
          <div class="banner-content-download-text">
            <div>
              <img src="@/assets/imgs/about/mobie-icon.png" alt="">
              <span>
                支持多平台 <br />
                双端互通
              </span>
            </div>
            <div>
              <img src="@/assets/imgs/about/user-black-icon.png" alt="">
              <span>
                简单 <br />
                易用
              </span>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="sub-menu">
      <div v-for="item in menuList" :class="`sub-menu-item ${activeMenu === item.key && 'sub-menu-item-active'}`"
        :key="'sub-menu-' + item.key" @click="handleMenu(item)" :style="`
          ${activeMenu === item.key &&  activeMenu === '1' && 'border-top-left-radius: 4px;border-bottom-left-radius: 4px;'}
          ${activeMenu === item.key &&  activeMenu === '4' && 'border-top-right-radius: 4px;border-bottom-right-radius: 4px;'}
        `">
        <div>
          <img :src="activeMenu === item.key ? item.selectIcon : item.icon" alt="">
          <span>{{ item.name }}</span>
        </div>
      </div>
    </div>

    <div class="content-box">
      <keep-alive>
        <product-first v-if="activeMenu === '1'"></product-first>
      </keep-alive>
      <keep-alive>
        <product-second v-if="activeMenu === '2'"></product-second>
      </keep-alive>
      <keep-alive>
        <product-third v-if="activeMenu === '3'"></product-third>
      </keep-alive>
      <keep-alive>
        <product-fourth v-if="activeMenu === '4'"></product-fourth>
      </keep-alive>
    </div>

    <base-footer v-if="showType" />
  </div>
</template>

<script>
import BaseHeader from '@/component/base-header';
import BaseFooter from '@/component/base-footer';
import ProductFirst from './components/productFirst';
import ProductSecond from './components/productSecond';
import ProductThird from './components/productThird';
import ProductFourth from './components/productFourth';
import MenuIcon1 from '@/assets/imgs/product/menu1.png'
import MenuIcon2 from '@/assets/imgs/product/menu2.png'
import MenuIcon3 from '@/assets/imgs/product/menu3.png'
import MenuIcon4 from '@/assets/imgs/product/menu4.png'
import MenuSelectIcon1 from '@/assets/imgs/product/menu-select1.png'
import MenuSelectIcon2 from '@/assets/imgs/product/menu-select2.png'
import MenuSelectIcon3 from '@/assets/imgs/product/menu-select3.png'
import MenuSelectIcon4 from '@/assets/imgs/product/menu-select4.png'

export default {
  name: 'Product',
  metaInfo: {
    title: '红狮金业产品,伦敦金交易_伦敦银交易|红狮金业正规贵金属交易产品',
    meta: [
      { name: 'keywords', content: '红狮金业产品,伦敦金交易,伦敦银交易,贵金属现货交易,香港贵金属交易产品' },
      { name: 'description', content: '“红狮金业提供合规伦敦金、伦敦银现货贵金属交易服务，实时同步国际行情，低点差、高速订单执行，搭配正版MT4/MT5交易软件，香港持牌运营交易更安心。' }
    ]
  },
  components: {
    BaseHeader,
    BaseFooter,
    ProductFirst,
    ProductSecond,
    ProductThird,
    ProductFourth,
  },
  data() {
    return {
      activeMenu: this.$route.query.key || '1',
      menuList: [
        { name: '产品介绍', key: '1', icon: MenuIcon1, selectIcon: MenuSelectIcon1 },
        { name: '账户介绍', key: '2', icon: MenuIcon2, selectIcon: MenuSelectIcon2 },
        { name: '产品细则', key: '3', icon: MenuIcon3, selectIcon: MenuSelectIcon3 },
        { name: '今日汇率', key: '4', icon: MenuIcon4, selectIcon: MenuSelectIcon4 },
      ],
      showType:true
    }
  },
  watch: {
    $route(nv){
      this.activeMenu = nv.query.key;
    }
  },
  created() {
    if (this.$route.query.from) {
      this.showType = false

    };
  },
  mounted() {

  },
  methods: {
    handleMenu(item) {
      this.activeMenu = item.key
    },
  },
}
</script>
<style lang="less" scoped>
.app-container {
  background: #fafafa;

  .content-box {
    width: 1240px;
    margin: auto;
    box-sizing: border-box;
  }

  .banner__layer {
    position: relative;
    // padding-top: 80px;
    .banner-img {
      display: block;
      width: 100%;
    }
    .banner-imgs {
      width: 100%;

      display: none;
    }
    .banner-content {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 11;
      color: #FFFFFF;
       .title{
        display: block;
       }
       .titles{
        display: none;
       }
      h1 {
        font-size: 68px;
        margin: 0;
      }
      &-intro {
        font-size: 18px;
      }
      &-download {
        display: flex;
        align-items: center;
        margin-top: 50px;

        &-btn {
          width: 198px;
          line-height: 56px;
          color: #FFFFFF;
          background: #FA2314;
          border-radius: 4px;
          margin-right: 10px;
          cursor: pointer;
          text-align: center;
          font-size: 20px;
          font-weight: 700;
          display: inline-block;
        }

        &-text {
          display: flex;
          align-items: center;

          >div {
            display: flex;
            align-items: center;
            color: #FFFFFF;
            padding: 4px 40px;

            &:first-child {
              border-right: 1px solid #0F0F11;
            }

            img {
              width: 38px;
              height: 38px;
              margin-right: 12px;
            }
          }
        }
      }
    }
  }

  .title__layer {
    text-align: center;
    padding: 70px 0 50px;
    h1 {
      font-size: 46px;
      margin: 0;
      color: #000;
      margin-bottom: 10px;
      span {
        color: #FA2314;
      }
    }
    p {
      color: #0F0F11;
      font-size: 18px;
    }
  }
  
  .sub-menu {
    width: 1240px;
    position: relative;
    margin: -50px auto 80px;
    display: flex;
    background: #FFFFFF;
    border-radius: 4px;
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.1);

    &-item {
      cursor: pointer;
      width: 25%;
      color: #000;
      position: relative;
      font-size: 20px;
      padding: 20px 0;

      > div {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 44px;
        border-right: 1px solid #C9C9CF;

      }

      &:last-child {
        > div {
          border: none;
        }
      }

      img {
        display: block;
        margin-right: 10px;
      }
    }

    &-item-active {
      background: #FA2314;
      color: #FFFFFF;

      > div {
        border-right: 0px;
      }

      &::after {
        content: "";
        position: absolute;
        bottom: -10px;
        left: 0;
        width: 0;
        height: 0;
        right: 0;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-top: 10px solid #FA2314;
        margin: auto;
      }
    }

  }

}
@media screen and (max-width: 500px) {
  .app-container{
    .banner__layer{
      padding-top: 45px;
      
        .banner-img{
          display: none;
        }
        .banner-imgs{
          display: block;
          height: 626px;
       
        }
      
      .banner-content {
      position: absolute;
      top: 35%;
      left: 50%;
      height: 375px;
      transform: translate(-50%, -50%);
      z-index: 11;
      padding-top: 40px;
      background: linear-gradient(180deg, #100005 68.28%, rgba(24, 24, 24, 0) 100%);
      // color: #000;
        color: #FFFFFF;

       .title{
        display: none;
      }
      .titles{
        color: #FFFFFF;
        display: block;
      }
      h1 {
        font-size: 58px;
        line-height: 77px;
        margin: 0;
        width: 100%;
        text-align: center;
        white-space: wrap;
      }
      &-intro {
        font-size: 14px;
        text-align: center;
      }
      &-download {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 20px;

        &-btn {
          width: 180px;
          line-height: 34px;
          color: #FFFFFF;
          background: #FA2314;
          border-radius: 4px;
          margin-right: 10px;
          cursor: pointer;
          text-align: center;
          font-size: 14px;
          font-weight: 700;
          margin-bottom: 20px;
        }

        &-text {
          display: flex;
          align-items: center;

          >div {
            display: flex;
            align-items: center;
            color: #0F0F11;
          color: #FFFFFF;

            padding: 2px 20px;
            font-size: 10px;
            &:first-child {
              border-right: 1px solid #fff;
            }

            img {
              width: 24px;
              height: 24px;
              margin-right: 12px;
            }
          }
        }
      }
    }
        .banner-co {
          top: 33%;
        }
    
        }
    
        .bannerss {
          padding-top: 0;
        }
    .content-box {
      width: 100%;
      margin: auto;
      box-sizing: border-box;
    }
    .title__layer {
      .title{
        display: none;
      }
      .titles{
        display: block;
      }
      h1{
        font-size: 36px;
        line-height: 48px;
      }
      p{
        font-size: 14px;
      }
    }
    .sub-menu {
      width: 80%;
    margin: -27px auto 80px;

      &-item {
        font-size: 12px;
        padding: 10px 0;

        > div {
          height: 17px;
        }
        img{
          display: none;
        }
      }
      &-item-active {
        &::after {
          bottom: -5px;
        }
      }
    }
  }
}
// -------------------------小屏幕适配-------------------
@media screen and (min-width: 1264px) and (max-width: 1724px) {
  .app-container {
      background: #fafafa;
  
      .content-box {
        width: 1000px;
        margin: auto;
        box-sizing: border-box;
      }
  
      .banner__layer {
        position: relative;
        // padding-top: 80px;
  
        .banner-img {
          display: block;
          width: 100%;
        }
  
        .banner-imgs {
          width: 100%;
  
          display: none;
        }
  
        .banner-content {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          z-index: 11;
          color: #FFFFFF;
  
          .title {
            display: block;
          }
  
          .titles {
            display: none;
          }
  
          h1 {
            font-size: 50px;
            margin: 0;
          }
  
          &-intro {
            font-size: 18px;
          }
  
          &-download {
            display: flex;
            align-items: center;
            margin-top: 50px;
  
            &-btn {
              width: 198px;
              line-height: 56px;
              color: #FFFFFF;
              background: #FA2314;
              border-radius: 4px;
              margin-right: 10px;
              cursor: pointer;
              text-align: center;
              font-size: 20px;
              font-weight: 700;
              display: inline-block;
            }
  
            &-text {
              display: flex;
              align-items: center;
  
              >div {
                display: flex;
                align-items: center;
                color: #FFFFFF;
                padding: 4px 40px;
  
                &:first-child {
                  border-right: 1px solid #0F0F11;
                }
  
                img {
                  width: 38px;
                  height: 38px;
                  margin-right: 12px;
                }
              }
            }
          }
        }
      }
  
      .title__layer {
        text-align: center;
        padding: 70px 0 50px;
  
        h1 {
          font-size: 46px;
          margin: 0;
          color: #000;
          margin-bottom: 10px;
  
          span {
            color: #FA2314;
          }
        }
  
        p {
          color: #0F0F11;
          font-size: 18px;
        }
      }
  
      .sub-menu {
        width: 1000px;
        position: relative;
        margin: -50px auto 80px;
        display: flex;
        background: #FFFFFF;
        border-radius: 4px;
        box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.1);
  
        &-item {
          cursor: pointer;
          width: 25%;
          color: #000;
          position: relative;
          font-size: 20px;
          padding: 20px 0;
  
          >div {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 44px;
            border-right: 1px solid #C9C9CF;
  
          }
  
          &:last-child {
            >div {
              border: none;
            }
          }
  
          img {
            display: block;
            margin-right: 10px;
          }
        }
  
        &-item-active {
          background: #FA2314;
          color: #FFFFFF;
  
          >div {
            border-right: 0px;
          }
  
          &::after {
            content: "";
            position: absolute;
            bottom: -10px;
            left: 0;
            width: 0;
            height: 0;
            right: 0;
            border-left: 10px solid transparent;
            border-right: 10px solid transparent;
            border-top: 10px solid #FA2314;
            margin: auto;
          }
        }
  
      }
  
    }
}
</style>